import React, { useState, useEffect, useContext } from 'react';
import {format, addDays, subDays} from "date-fns";

import * as net from "../../../lib/net";
import * as utils from "../../../assets/utils";

class Dlg_Nota extends React.Component {
  constructor(props, context) {
    super(props);

    this.store = props.store;
    this.pos = props.store.pos;

    this.state = {};
    this.state.today = new Date();
    this.state.rta = [];
    this.state.tra = [];

    this.state.gnr = "001";
    this.state.gso = {};

    this.state.ynq = [
                {id: '0', text: 'NEJ'},
                {id: '1', text: 'JA'}
            ];

    this.state.rs = "";
    this.state.rso = {};
    this.state.background = "#fff";
    this.state.nto = {};

    this.state.today = new Date();
    var dts = format(this.state.today, "yyyy-MM-dd");
    this.state.tdts = dts;
    this.state.dts = dts;

    this.state.notanr = "";

    this.state.sortid = "";
    this.state.sortdir = "";
    this.state.wnds = {};
    if(props.wnds) {
      this.state.notanr = props.wnds.notanr;
      if(props.wnds.dts) this.state.dts = props.wnds.dts;
    }
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.nota_trs();
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
    grp_style(row) {
      var css = {};
      css.background = "#008";
      if(this.state.gnr === row.vgrupp) css.background = "#080";
      return css;
    }

    formchange (e) {
      const name = e.target.name;
      const value = e.target.value;
      var pbo = this.state.pbo;
      var na = name.split(".");
      pbo[na[0]][na[1]] = value;
      this.setState({pbo: pbo});
      //setState({[name]: value});
    }

    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({user: user});
      //setState({[name]: value});
    }
    wnd_close = () => {
      if(this.props.cb) {
        var ret = {};
        ret.ok = "999";
        this.props.cb(this.props.ctx, ret);
      }
      else this.props.ctx.setState({ wnds: {} });
	};

  submitHandler = event => {
    event.preventDefault();
    event.target.className += " was-validated";
  };

    val_save (name, value) {
        //alert(JSON.stringify(name));
        //alert(JSON.stringify(value));
      var rso = this.state.rso;
        rso[name] = value;
      this.setState({rso: rso});
    }
    cb_save (name, e) {
      const value = e.target.value;
      var bro = this.state.bro;
      bro[name] = value;
      this.setState({bro: bro});
      //setState({[name]: value});
    }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }
  th_style(id) {
    var css = {};
    css.cursor = "pointer";
    if(id == this.state.sortid) css.color = "#080";
    return css;
}
tb_sort(typ) {
    var self = this;

    var tra = self.state.tra;
    var sortid = this.state.sortid;
    var sortdir = this.state.sortdir;

    if(sortid != typ) sortdir = 0;
    else {
        if(sortdir) sortdir = 0;
        else sortdir = 1;
    }
    if(true) {
        if(sortdir) tra.sort((a,b) => (a[typ] < b[typ]) ? 1 : ((b[typ] < a[typ]) ? -1 : 0));
        else tra.sort((a,b) => (a[typ] > b[typ]) ? 1 : ((b[typ] > a[typ]) ? -1 : 0));
    }
    self.setState({ tra: tra, sortid: typ, sortdir: sortdir });
  }

  nota_trs() {
    var self = this;

    self.setState({ tra: [] });
    if(this.state.dts == this.state.tdts) {
        self.nota_act();
    }
    else
    {
        self.nota_hist();
    }
}

  nota_act() {
    var self = this;
    var prm = {};
    prm.req = "pos.pos_eko.nota_kopia";
    //prm.avd = ddo.cache.avd;
    prm.avd = "01";
    prm.notanr = self.state.notanr;

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({ nto: ret.rco, tra: ret.rco.rows });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
  nota_hist() {
    var self = this;
    var prm = {};
    prm.req = "pos.pos_eko.invh_copy";
    //prm.avd = ddo.cache.avd;
    prm.avd = "01";
    prm.notanr = self.state.notanr;
    prm.datum = self.state.dts;

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({ nto: ret.rco, tra: ret.rco.rows });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }

  render() {

	var html =
        <div className="mx_base">
        <div className="m3_backdrop" />
        <div className="m3_dlg mx_100 flex-col" style={ this.dlg_style() } >

        <div className="mx_h01">
            <div>NOTA</div>
        </div>
        <div className="mx_content flex">

        <div className="divider_orange"></div>
        <div className="">Bord: { utils.toNum(this.state.nto.bordnr) }</div>
        <div className="">Notanr: { utils.toNum(this.state.nto.notanr) }</div>
        <div className="">Kassör: { utils.toLang(this.state.nto.ctxt) }</div>
        <div className="">Fsg: { utils.toPris(this.state.nto.fsg) }</div>
        <div className="">Start-Slut: { utils.toTid(this.state.nto.start) } - { utils.toTid(this.state.nto.slut) }</div>
        <div className="divider_orange py-2"></div>

            <div className="flex">
                <table className="table table-bordered table-hover tb fixed_header">
                    <thead>
                    <tr>
                    <th style={ this.th_style("r0time") } onClick={() => this.tb_sort("r0time") }>Tid</th>
                    <th style={ this.th_style("r0sign") } onClick={() => this.tb_sort("r0sign") }>Kassör</th>
                        <th style={ this.th_style("r0text") } onClick={() => this.tb_sort("r0text") }>Text</th>
                        <th style={ this.th_style("r0noof") } onClick={() => this.tb_sort("r0noof") }>Antal</th>
                        <th style={ this.th_style("r0perprice") } onClick={() => this.tb_sort("r0perprice") }>Belopp</th>
                    </tr>
                    </thead>
                    <tbody style={ this.tb_style() }>
                    { this.state.tra.map((row, key) =>
                    <tr key={key} onDoubleClick={() => this.row_open(row) }>
                        <td>{ row.r0time.cditid() }</td>
                        <td>{ utils.toLang(row.ctxt) }</td>
                        <td className="text-left">{ row.r0text.toswe().trim() }</td>
                        <td className="text-center">{ row.r0noof.ztrim() }</td>
                        <td className="text-right">{ row.r0perprice.cdipris() }</td>
                    </tr>
                    )}
                    </tbody>
                </table>
            </div>

        </div>

        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red flex" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
        </div>
      </div>

      </div>
	;
	return html;
  };
}

export default Dlg_Nota;
